import { LRUCache } from 'lru-cache';
import { defineStore } from 'pinia';
import { useStoreRoot } from '../abstract/root';
import httpInstance from './httpInstance';
import type { TLanguage } from '~/types/language';

export const cache = new LRUCache({
  ttl: 1000 * 86400,
  ttlAutopurge: true,
});

if (import.meta.server) {
  import('tx2')
    .then((tx2) => {
      if (import.meta.server) {
        tx2.default.action('clearcache', (reply) => {
          cache.clear();
          reply({ answer: 'Cache cleared!' });
        });
      }
    })
    .catch((e) => {
      if (import.meta.server) {
        console.error(e, 'Error in tx2 import');
      }
    });
}

export const strapi = defineStore('transportStrapi', {
  actions: {
    async get(dataName: string, params?: string, locale?: TLanguage): Promise<any | null> {
      try {
        let url = '';

        const paramsString = `locale=${locale || useStoreRoot().userLang}${
          params ? '&' + params : ''
        }&pagination[pageSize]=1000`;

        const host =
          import.meta.browser && window.location?.host
            ? window.location.host
            : 'dev.7bitcasino.com';

        if (import.meta.server) {
          url =
            process.env.NUXT_REWRITE_STRAPI_HOST ||
            process.env.NUXT_DEFAULT_STRAPI_HOST ||
            `https://${host}/strapi`;
        } else {
          const isLocal =
            (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development') &&
            window.location.host.includes('local');

          const urlBasedOnEnv =
            (useRuntimeConfig().public.REWRITE_STRAPI_HOST as string) ||
            (useRuntimeConfig().public.DEFAULT_STRAPI_HOST as string) ||
            (`https://${host}/strapi` as string);

          url = isLocal ? urlBasedOnEnv : `https://${host}/strapi`;
        }

        if (!['dev.', 'notifications'].some((el) => url.includes(el))) {
          const cachedResponse = cache.get(`${url}/${dataName}?${paramsString}`);
          if (cachedResponse) {
            return cachedResponse;
          }
        }

        const http = httpInstance(url);
        const response = await http.get(`${url}/${dataName}?${paramsString}`);

        if (!['dev.', 'notifications'].some((el) => url.includes(el))) {
          cache.set(`${url}/${dataName}?${paramsString}`, response.data);
        }

        return response.data;
      } catch (error) {
        console.error(error);
        console.error('STRAPI ERROR: ', dataName, params);

        return null;
      }
    },
    clearCache() {
      cache.clear();
    },
  },
});
